var base = require('kiosk/add-discount');

Vue.component('spark-kiosk-add-discount', {
    mixins: [base]
});



// WEBPACK FOOTER //
// ./resources/js/spark-components/kiosk/add-discount.js